export const globalContractColumns = [
  { label: 'Practice Name', key: 'practiceName', apiKey: 'Practice_Name' },
  { label: 'Provider Name', key: 'providerName', apiKey: 'Provider_Name' },
  { label: 'Primary Office Address', key: 'primaryOfficeAddress', apiKey: 'Primary_Office_Address' },
  { label: 'City', key: 'city', apiKey: 'City' },
  { label: 'State', key: 'state', apiKey: 'State' },
  { label: 'Zip', key: 'zip', apiKey: 'Zip' },
  { label: 'Code Type', key: 'codeType', apiKey: 'Code_Type' },
  { label: 'Code', key: 'code', apiKey: 'Code' },
  { label: 'Description', key: 'description', apiKey: 'Description' },
  { label: 'Gross Bundle', key: 'grossBundle', apiKey: 'Gross_Bundle' },
];

export const globalContractSearchDelay = 1000;
export const globalContractPageSize = 10;

export const initialGlobalContractFormValues = {
  contactName: '',
  contactEmail: '',
  patientFirstName: '',
  patientLastName: '',
  patientId: '',
  patientDate: '',
};

export const globalContractEmailPattern = '[^\\s@]+@[^\\s@]+\\.[A-Za-z]{2,}';

export const contractCurrencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const contractTermsDateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
});

export const globalContractTermsTitle = 'Terms and Conditions of Use and Participation';

export const globalContractTermsContent = `Terms and Conditions Agreement
Effective Date: {{effectiveDate}}

Please read these Terms and Conditions ("Agreement") carefully before submitting an application through this website. By accessing this website, submitting an application, or accepting an offer through the platform, you acknowledge that you have read, understood, and agree to be legally bound by these Terms and Conditions.

1. Purpose of the Platform
This website facilitates the submission of applications by healthcare providers, facilities, payers, employers, and other authorized entities seeking approval to participate in a medical cost-savings program. Approved applicants may access negotiated reimbursement rates for eligible medical procedures and services, subject to the terms of this Agreement.
Submission of an application does not guarantee approval or participation. Approval is granted solely at the discretion of the program administrator.

2. Acceptance of Predefined Rates
Upon approval and acceptance into the program, the applicant agrees to utilize the predefined reimbursement rates established through the platform for covered procedures and services.
The participant acknowledges that:
The negotiated rates constitute the agreed reimbursement for applicable procedures.
The participant will not seek reimbursement in excess of the agreed contracted amount for services covered under the program, except where required by applicable law or expressly authorized in writing.
All pricing and reimbursement are subject to applicable federal and state laws and regulations.

3. Access Fee
In consideration for access to the negotiated pricing network and related services, the participant agrees to pay an access fee equal to twenty percent (20%) of the verified savings generated through utilization of the program.
For purposes of this Agreement:
Savings means the difference between the participant's original billed amount, usual and customary charge, contracted rate, or other applicable benchmark (as determined by the program administrator) and the negotiated reimbursement amount accepted through the program.
The 20% access fee shall become due and payable upon realization of the savings in accordance with the program's billing procedures.
The participant authorizes the program administrator to invoice for such fees and agrees to remit payment within the time specified on the invoice.

4. Verification of Savings
The participant agrees to provide all documentation reasonably necessary to calculate and verify savings, including but not limited to:
Billing records
Explanation of Benefits (EOBs)
Payment records
Supporting claim documentation
Other information reasonably requested
The program administrator reserves the right to audit transactions for purposes of determining savings and calculating fees.

5. Accurate Information
The participant represents and warrants that all information submitted through the website is true, complete, and accurate.
The participant agrees to promptly notify the program administrator of any material changes to submitted information.
Submission of false or misleading information may result in denial, suspension, or termination of participation.

6. Compliance with Laws
The participant agrees to comply with all applicable federal, state, and local laws, including but not limited to laws governing healthcare billing, fraud and abuse, privacy, reimbursement, and applicable licensing requirements.
Nothing in this Agreement shall require any party to violate applicable law or regulation.

7. Confidentiality
Each party agrees to maintain the confidentiality of proprietary, pricing, business, and non-public information obtained through participation in the program.
Confidential information shall not be disclosed except:
As required by law;
To authorized representatives with a legitimate business need;
With prior written consent of the disclosing party.

8. Privacy
The participant acknowledges that the website may collect personal and business information necessary to process applications and administer the program.
Information will be handled in accordance with the platform's Privacy Policy and applicable privacy laws.
If protected health information (PHI) is exchanged, each party agrees to comply with applicable HIPAA requirements where applicable.

9. No Guarantee of Approval
Submission of an application does not create any contractual relationship until the application has been reviewed and approved.
The program administrator reserves the sole right to approve, deny, or revoke participation.

10. Intellectual Property
All website content, trademarks, software, forms, pricing methodologies, documentation, and proprietary materials remain the exclusive property of the program administrator and may not be copied, reproduced, distributed, or modified without prior written permission.

11. Limitation of Liability
To the fullest extent permitted by law, the program administrator shall not be liable for indirect, incidental, consequential, special, or punitive damages arising out of participation in the program or use of the website.
The participant's exclusive remedy shall be limited to direct damages actually incurred, subject to applicable law.

12. Indemnification
The participant agrees to indemnify, defend, and hold harmless the program administrator, its affiliates, officers, directors, employees, contractors, and agents from any claims, damages, liabilities, costs, or expenses arising from:
Breach of this Agreement;
Misrepresentation of submitted information;
Violation of applicable laws;
Improper billing or reimbursement practices.

13. Termination
Either party may terminate participation in accordance with the applicable participation agreement.
Termination shall not relieve either party of obligations accrued prior to termination, including payment of earned access fees.

14. Electronic Consent
The participant agrees that checking the acceptance box, electronically signing, or clicking "I Agree," "Submit," or similar acceptance constitutes an electronic signature and has the same legal force and effect as a handwritten signature.

15. Governing Law
This Agreement shall be governed by and construed in accordance with the laws of the State of [Insert State], without regard to conflict-of-law principles.
Any disputes arising under this Agreement shall be resolved in the state or federal courts located within the applicable jurisdiction.

16. Entire Agreement
These Terms and Conditions constitute the entire agreement regarding use of the website and participation in the program and supersede all prior discussions, negotiations, or understandings relating to the subject matter herein.

Acknowledgment
By selecting "I Agree" and submitting an application, I acknowledge and certify that:
I have read and understand these Terms and Conditions.
I have authority to bind the individual or organization submitting this application.
I agree to utilize the predefined reimbursement rates upon approval.
I understand and agree to pay an access fee equal to 20% of the verified savings generated through use of the program.
I agree to comply with all applicable laws and program requirements.
I consent to the use of electronic records and electronic signatures.`;
